import {
  SIDE_MENU_COLLAPSED,
  DETAIL_SHOWED,
  LOADING,
  SERVER_ERRORS,
} from "../types";

const initialState = {
  collapsed: false,
  showDetail: false,
  editing: false,
  loading: true,
  errors: {},
};

const common = (state = initialState, action: any) => {
  switch (action.type) {
    case SIDE_MENU_COLLAPSED:
      return {
        ...state,
        collapsed: action.collapsed,
      };
    case DETAIL_SHOWED:
      return {
        ...state,
        showDetail: action.showDetail,
      };
    case LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case SERVER_ERRORS:
      return {
        ...state,
        errors: action.errors,
      };

    default:
      return state;
  }
};

export default common;



